import Utils from "@/ecm/common/Utils.js"

export default class Signature {
    constructor(dto) {
        this.id = 0;
        this.description = "";
        this.isDefault = false;
        this.signatureImage = null;
        this.signatureImageHasChanged = true;

        this.includeFrame = false;
        this.includeUserFullName = false;
        this.includeTimeStamp = false;

        this.imagePositionX = 0;
        this.imagePositionY = 0;
        this.imageSizeX = 0;
        this.imageSizeY = 0;


        if (dto) {
            this.id = dto.Id;
            this.description = dto.Description;
            this.isDefault = dto.IsDefault;
            this.signatureImageHasChanged = dto.SignatureImageHasChanged;
            this.includeFrame = dto.IncludeFrame;
            this.includeUserFullName = dto.IncludeUserFullName;
            this.includeTimeStamp = dto.IncludeTimeStamp;
            this.imagePositionX = dto.ImagePositionX;
            this.imagePositionY = dto.ImagePositionY;
            this.imageSizeX = dto.ImageSizeX;
            this.imageSizeY = dto.ImageSizeY;
        }
    }

    toDto() {
        return {
            Id: this.id,
            Description: this.description,
            IsDefault: this.isDefault,
            SignatureImageHasChanged: this.signatureImageHasChanged,
            SignatureImage: this.getImage(),
            IncludeFrame: this.includeFrame,
            IncludeUserFullName: this.includeUserFullName,
            IncludeTimeStamp: this.includeTimeStamp,
            ImagePositionX: this.imagePositionX,
            ImagePositionY: this.imagePositionY,
            ImageSizeX: this.imageSizeX,
            ImageSizeY: this.imageSizeY
        }
    }

    getImage() {
        if (this.signatureImage) {
            const image = Utils.file.image.getBase64(this.signatureImage);

            return {
                FileName: `signature_img.${image.extension}`,
                Base64File: image.data
            }
        }
    }
}